import styled from 'styled-components';

import { GameStatus } from '@sorare/core/src/__generated__/globalTypes';
import { Tag } from '@sorare/core/src/atoms/ui/Tag';

import { DecimalScore } from '@sorare/us-sports/src/components/scores/DecimalScore';

import { GameTimeStatusTag } from '../GameTimeStatusTag';

const GamePlayerScore = styled(Tag)`
  font-size: calc(1.5 * var(--unit));
  font-weight: 600;
  padding: var(--half-unit) var(--unit);
`;

type Props = {
  startDate: Date;
  status: GameStatus;
  cardScore?: number;
  hideDay?: boolean;
  quarter: number;
  isHalftime: boolean;
};

export const StatusRow = ({
  startDate,
  status,
  cardScore,
  quarter,
  isHalftime,
  hideDay,
}: Props) => {
  return (
    <>
      <GameTimeStatusTag
        status={status}
        startDate={startDate}
        quarter={quarter}
        isHalftime={isHalftime}
        hideDay={hideDay}
      />

      {typeof cardScore === 'number' && (
        <GamePlayerScore color="black">
          <DecimalScore value={cardScore!} />
        </GamePlayerScore>
      )}
    </>
  );
};
